import { render, staticRenderFns } from "./TabContasPagar.vue?vue&type=template&id=231e2ec0&scoped=true&"
import script from "./TabContasPagar.vue?vue&type=script&lang=js&"
export * from "./TabContasPagar.vue?vue&type=script&lang=js&"
import style0 from "./TabContasPagar.vue?vue&type=style&index=0&id=231e2ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e2ec0",
  null
  
)

export default component.exports